import { useMemo } from 'react';
import { useLocale } from '../../../context/LocaleContext';
import { getFirstDayOfWeek } from '../operators/getFirstDayOfWeek';
export function useCalendarLocale(current) {
  const locale = useLocale();
  const firstDayOfWeek = useMemo(() => getFirstDayOfWeek(locale), [locale]);
  const monthLabel = useMemo(() => new Intl.DateTimeFormat(locale, {
    month: 'long',
    year: 'numeric'
  }).format(new Date(current.year, current.month, 1)), [locale, current]);
  return {
    firstDayOfWeek,
    monthLabel
  };
}